module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"AI真人實穿照說明","description_title":"請上傳真人實穿照","description_content":"上傳照片後，AI將透過分析判斷是否為真人實穿照。請上傳穿著商品並露出身體部位（眼、鼻、嘴、手臂、腿、腰部等）的照片。","disclaimer":"*由 AI 分析模型判定，分析結果可能會有誤差。"}}')
  delete Component.options._Ctor
}
